import styled from 'styled-components';
import { WarningAmberRounded } from '@mui/icons-material';
import colors from '../../../../../styles/colors';

const ActionButtonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
`;

const DialogContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

const MaxUsersContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const CapacityLabel = styled.div`
  padding: 4px 8px;
  border-radius: 4px;
  font-weight: 500;
  text-align: center;
  color: white;
  width: 60px;
  
  &.green {
    background-color: ${colors.shades.success3};
  }
  
  &.amber {
    background-color: ${colors.shades.primary2};
  }
  
  &.red {
    background-color: ${colors.shades.danger3};
  }
`;

const WarningIcon = styled(WarningAmberRounded)`
  color: ${colors.shades.danger1};
  font-size: 20px;
`;

const EditContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: space-around;
  width: 100%;
  padding-right: 32px; 
`;

const EditInput = styled.input`
  padding: 4px;
  border: 1px solid ${colors.shades.secondary7};
  border-radius: 4px;
  min-width: 0;
  flex-grow: 1;
  margin-right: 8px;
`;

const NameDisplay = styled.span`
   flex-grow: 1;
   margin-right: 8px;
   display: flex;
   align-items: center;
   gap: 8px;
`;

const SavingText = styled.div`
  font-size: 14px;
  color: ${colors.base.secondary2};
  opacity: 0.8;
`;

export {
  ActionButtonContainer,
  DialogContentContainer,
  MaxUsersContainer,
  CapacityLabel,
  WarningIcon,
  EditContainer,
  EditInput,
  NameDisplay,
  SavingText,
};
